import { useEffect, useRef } from 'react';

/**
 * While `isOpen` is true, Escape invokes `onClose` (document-level listener).
 * @param {boolean} isOpen
 * @param {() => void} onClose
 * @param {{ enabled?: boolean }} [options] If `enabled` is false, Escape is ignored (e.g. while saving).
 */
export function useModalEscapeKey(isOpen, onClose, options = {}) {
  const { enabled = true } = options;
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isOpen || !enabled) return undefined;
    const handler = (e) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      const fn = onCloseRef.current;
      if (typeof fn === 'function') fn();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen, enabled]);
}
